import { render, staticRenderFns } from "./WsDemoExamsApprove.vue?vue&type=template&id=4b7c9d0b"
import script from "./WsDemoExamsApprove.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports